import React, { useMemo, useRef } from "react";

import { faMobile } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";

import AgGridTable from "components/AgGrid/AgGridContainer";

import { AgGridTables } from "constants/aggrid";

import {
  getLivestockSaleId,
  getReceivalScanLotCardsRoute,
  getSaleyardName,
} from "lib/navigation";

import { getReceivalLotAggridData } from "selectors/aggrid/receivalLots";

import { useDebounceSelector, useSetScreenSize } from "hooks";

import { receivalLotColumns } from "./columnDefinitions";

export const ReceivalLotsTable = () => {
  const history = useHistory();
  const rowData = useDebounceSelector(getReceivalLotAggridData);
  const agGridApiRef = useRef();
  const { setMobile } = useSetScreenSize();

  function onGridReady({ api }) {
    agGridApiRef.current = api;
  }

  const additionalActions = useMemo(
    () => [
      {
        title: "Mobile View",
        icon: faMobile,
        onClick: () => {
          setMobile();
          history.push(
            getReceivalScanLotCardsRoute(
              getSaleyardName(),
              getLivestockSaleId(),
            ),
          );
        },
        dataTour: "mobileView",
      },
    ],
    [history, setMobile],
  );

  return (
    <AgGridTable
      additionalActions={additionalActions}
      columnDefs={receivalLotColumns}
      onGridReady={onGridReady}
      rowData={Object.values(rowData)}
      tableName={AgGridTables.RECEIVAL_LOT}
    />
  );
};
